import { render, staticRenderFns } from "./ListDetail.vue?vue&type=template&id=5a429468&scoped=true&"
import script from "./ListDetail.vue?vue&type=script&lang=js&"
export * from "./ListDetail.vue?vue&type=script&lang=js&"
import style0 from "./ListDetail.vue?vue&type=style&index=0&id=5a429468&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a429468",
  null
  
)

export default component.exports